import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ProjectExplore from 'src/pages/project/ProjectExplore';
// import ProjectQuotes from 'src/pages/project/ProjectQuotes';

export default function ExploreRoutes() {
  return (
    <Routes>
      <Route path="/:projectId/*" element={<ExploreSubroutes />} />
    </Routes>
  );
}

function ExploreSubroutes() {
  return (
    <Routes>
      <Route path="/" element={<ProjectExplore />} />
    </Routes>
  );
}
